import React from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import './franchise.css';

function Franchise() {
  return (
    <div className='franchisesec'>
        <div className="coursessec">
            <div className="introabout">
                <p className="abouttitle">Franchise</p>
                <p className="subabout">Home <span><ArrowForwardIosIcon className='spanicon' /><ArrowForwardIosIcon className='spanicon1' /></span> Franchise</p>
            </div>
        </div>
        <p className="franchiseconent">
        Thanks for showing interest in Franchise of H & B Computer Education.<br/><br/><br/>
        The Indian education market is one of the most promising markets now and is going to swell in the future. The adoption of technology in this sector has opened flood gates of opportunities for the entrepreneurs, businessman and start-ups to get their roots firmed in the business.<br/><br/>
        The Indian education market is expected to almost double to $180 billion by 2020, buoyed by the rapid expansion of the digital learning market.
        Franchise business in India is one of the safest formats as it involves less investment coupled with more revenue. This is the reason why more and more people are now moving towards this arrangement and taking advantage of Low investment franchise business across the India.<br/><br/><br/><br/>
        Grasping H & B Franchise Opportunity at this time implies that your future is guaranteed for additional benefits.
        “About 89% of the employment opportunities demand vocational skills, but 89% of the schools & colleges deliver only bookish knowledge.”
        Here is where we at H & B Computer Education play a crucial role of bridging the gap between Employment and Employability.
        We invite you to be a part of this movement. Let’s bridge this gap across the Globe. We are looking for Partners to associate with us in this mission.
        </p>

        <section class="contact" />
              <div class="cont container">
                  <div class="contact-text">
                      <p>Drop your inquiry here and our experts will get back to you.</p>
                      <h6>Address</h6>
                      <p class="address">
                      35, 2nd floor, Vinay arcade,Nr. Kamal Choice, Opp. Maninagar Rly. Station,Ahmedabad, Gujarat
                      </p>
                      <h6>Email</h6>
                      <p class="mail">info@hnbinfo.com</p>
                  </div>
                  <div class="contact-form">
                      <form/>
                          <label for="name" className='secname'>Name :</label>
                          <input type="text" name="name" id="name" required/><br/>
                              <label for="email" className='secname1'>Email :</label>
                              <input type="email" name="email" id="email" required/><br/>
                                  <label for="message" className='secname'>Message :</label>
                                  <textarea name="message" id="message" cols="30" rows="5" required></textarea><br/>
                                  <input type="submit" className='secbutton' value="submit"/>
                                  <form />
                              </div>
                          </div>
        <section />
        
    </div>
  )
}

export default Franchise